document.addEventListener('DOMContentLoaded', () => {

  // ── Gallery ─────────────────────────────────────────
  const mainImg = document.getElementById('lp-main-img')
  document.querySelectorAll('.lp-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (mainImg) mainImg.src = thumb.dataset.src
      document.querySelectorAll('.lp-thumb').forEach(t => t.classList.remove('active'))
      thumb.classList.add('active')
    })
  })

  // ── Buy Box ─────────────────────────────────────────
  const PRICES = {
    sub: { 1: 29, 2: 46, 3: 57 },
    one: { 1: 40, 2: 80, 3: 120 }
  }
  const SERVINGS_PER_BAG = 30

  const buyBox     = document.getElementById('lp-buy-box')
  const atcBtn     = document.getElementById('lp-atc')
  const flavorRows = Array.from(document.querySelectorAll('.lp-flavor-row'))

  let selectedBags = 2
  let isSubscribe  = true

  function initFlavors(bags) {
    flavorRows.forEach((row, i) => {
      const qty = i < bags ? 1 : 0
      row.querySelector('.lp-qty-val').textContent = qty
      row.querySelector('.lp-qty-servings').textContent = qty * SERVINGS_PER_BAG + ' servings'
    })
  }

  function totalFlavors() {
    return flavorRows.reduce((sum, row) => {
      return sum + parseInt(row.querySelector('.lp-qty-val').textContent)
    }, 0)
  }

  function updateBundleStyles() {
    document.querySelectorAll('.lp-bundle-card').forEach(card => {
      const bags     = parseInt(card.dataset.bags)
      const selected = bags === selectedBags
      card.style.border     = selected ? '2px solid #302D7F' : '1.5px solid #e4e0f0'
      card.style.background = selected ? '#f8f6ff' : 'white'
    })
  }

  function updatePrices() {
    const subTotal = PRICES.sub[selectedBags]
    const oneTotal = PRICES.one[selectedBags]
    const activeTotal = isSubscribe ? subTotal : oneTotal

    document.getElementById('lp-sub-price').textContent = '$' + subTotal
    document.getElementById('lp-one-price').textContent = '$' + oneTotal
    document.getElementById('lp-sub-desc').textContent  =
      'Delivered every 30 days · ' + (selectedBags * SERVINGS_PER_BAG) + ' servings'
    document.getElementById('lp-one-desc').textContent  =
      (selectedBags * SERVINGS_PER_BAG) + ' servings · delivered once'

    document.querySelectorAll('.lp-bundle-card').forEach(card => {
      const bags   = parseInt(card.dataset.bags)
      const subP   = parseInt(card.dataset.sub)
      const oneP   = parseInt(card.dataset.one)
      const priceEl = card.querySelector('.lp-card-price')
      const oldEl   = card.querySelector('.lp-card-old')
      if (priceEl) priceEl.textContent = '$' + (isSubscribe ? subP : oneP)
      if (oldEl)   oldEl.textContent   = isSubscribe ? '$' + oneP : ''
    })

    atcBtn.textContent = '+ START NOW - $' + activeTotal

    const wrap = document.getElementById('lp-purchase-wrap')
    if (wrap) wrap.style.borderColor = isSubscribe ? '#428F34' : '#e4e0f0'
  }

  // ── Bundle selection via radio change ───────────────
  document.querySelectorAll('input[name="lp-bags"]').forEach(radio => {
    radio.addEventListener('change', () => {
      selectedBags = parseInt(radio.value)
      initFlavors(selectedBags)
      updateBundleStyles()
      updatePrices()
    })
  })

  // ── Flavor qty +/- ──────────────────────────────────
  flavorRows.forEach(row => {
    const minusBtn = row.querySelector('.lp-qty-minus')
    const plusBtn  = row.querySelector('.lp-qty-plus')
    const qtyEl    = row.querySelector('.lp-qty-val')
    const servEl   = row.querySelector('.lp-qty-servings')

    plusBtn.addEventListener('click', (e) => {
      e.preventDefault()
      const current = parseInt(qtyEl.textContent)
      if (totalFlavors() >= selectedBags) return
      qtyEl.textContent  = current + 1
      servEl.textContent = (current + 1) * SERVINGS_PER_BAG + ' servings'
    })

    minusBtn.addEventListener('click', (e) => {
      e.preventDefault()
      const current = parseInt(qtyEl.textContent)
      if (current <= 0) return
      qtyEl.textContent  = current - 1
      servEl.textContent = (current - 1) * SERVINGS_PER_BAG + ' servings'
    })
  })

  // ── Purchase type toggle ─────────────────────────────
  document.querySelectorAll('input[name="lp-purchase-type"]').forEach(radio => {
    radio.addEventListener('change', () => {
      isSubscribe = radio.value === 'sub'
      const subLabel = document.getElementById('lp-opt-sub')
      const oneLabel = document.getElementById('lp-opt-one')
      if (subLabel) subLabel.style.background = isSubscribe ? '#f6fdf4' : 'white'
      if (oneLabel) oneLabel.style.background = isSubscribe ? 'white' : '#f8f6ff'
      updatePrices()
    })
  })

  // ── ATC ─────────────────────────────────────────────
  atcBtn.addEventListener('click', () => {
    const planId = buyBox ? buyBox.dataset.planId : null

    if (totalFlavors() !== selectedBags) {
      const original = atcBtn.textContent
      atcBtn.textContent = 'Select ' + selectedBags + ' flavor(s) to continue'
      setTimeout(() => { atcBtn.textContent = original }, 2000)
      return
    }

    const items = []
    flavorRows.forEach(row => {
      const qty = parseInt(row.querySelector('.lp-qty-val').textContent)
      if (qty > 0) {
        const item = { id: parseInt(row.dataset.variantId), quantity: qty }
        if (isSubscribe && planId) item.selling_plan = parseInt(planId)
        items.push(item)
      }
    })

    const originalText = atcBtn.textContent
    atcBtn.textContent = 'Adding...'
    atcBtn.disabled = true

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(res => res.json())
    .then(() => {
      atcBtn.textContent = 'Added! ✓'
      atcBtn.style.background = '#428F34'
      setTimeout(() => {
        atcBtn.style.background = 'linear-gradient(135deg, #E60C64, #302D7F)'
        atcBtn.textContent = originalText
        atcBtn.disabled = false
      }, 1500)

      const triggers = [
        '[data-cart-toggle]',
        '[data-drawer-toggle="cart-drawer"]',
        '#cart-icon-bubble',
        '.cart-count-bubble',
        'a[href="/cart"].header__icon',
        '[data-cart-open]'
      ]
      let opened = false
      for (const sel of triggers) {
        const el = document.querySelector(sel)
        if (el) { el.click(); opened = true; break }
      }
      if (!opened) window.location.href = '/cart'
    })
    .catch(() => {
      atcBtn.style.background = 'linear-gradient(135deg, #E60C64, #302D7F)'
      atcBtn.textContent = originalText
      atcBtn.disabled = false
    })
  })

  // ── Init ─────────────────────────────────────────────
  initFlavors(selectedBags)
  updateBundleStyles()
  updatePrices()

  // ── Accordion ────────────────────────────────────────
  document.querySelectorAll('.lp-accordion-item').forEach(item => {
    item.querySelector('.lp-accordion-trigger').addEventListener('click', () => {
      const isOpen = item.classList.contains('open')
      document.querySelectorAll('.lp-accordion-item').forEach(i => i.classList.remove('open'))
      if (!isOpen) item.classList.add('open')
    })
  })

  // ── FAQ ──────────────────────────────────────────────
  document.querySelectorAll('.lp-faq-item').forEach(item => {
    item.querySelector('.lp-faq-trigger').addEventListener('click', () => {
      const isOpen = item.classList.contains('open')
      document.querySelectorAll('.lp-faq-item').forEach(i => i.classList.remove('open'))
      if (!isOpen) item.classList.add('open')
    })
  })

  // ── Smooth scroll CTAs ───────────────────────────────
  document.querySelectorAll('.lp-scroll-cta').forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault()
      document.getElementById('product-block')?.scrollIntoView({ behavior: 'smooth' })
    })
  })

  // ── UGC Videos ──────────────────────────────────────
  const ugcVideos = document.querySelectorAll('.lp-ugc-video')
  ugcVideos.forEach(video => {
    const card = video.parentElement
    card.addEventListener('mouseenter', () => { video.play() })
    card.addEventListener('mouseleave', () => { video.pause(); video.currentTime = 0 })
    card.addEventListener('click', () => {
      video.muted = !video.muted
      let ind = card.querySelector('.lp-mute-ind')
      if (!ind) {
        ind = document.createElement('div')
        ind.className = 'lp-mute-ind'
        ind.style.cssText = 'position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background:rgba(0,0,0,0.6);color:white;font-size:28px;width:56px;height:56px;border-radius:50%;display:flex;align-items:center;justify-content:center;pointer-events:none;z-index:10;transition:opacity 0.3s'
        card.appendChild(ind)
      }
      ind.textContent = video.muted ? '🔇' : '🔊'
      ind.style.opacity = '1'
      setTimeout(() => ind.style.opacity = '0', 800)
    })
  })

  if (window.innerWidth < 768 && ugcVideos.length > 0) {
    ugcVideos[0].play()
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) e.target.play()
        else { e.target.pause(); e.target.currentTime = 0 }
      })
    }, { threshold: 0.6 })
    ugcVideos.forEach(v => obs.observe(v))
  }

})